import { CustomControlCode } from '@common/enums';
import { initialHolterReadOutData } from '@common/validation/customControls/cardiology/holter/holterReadOutSchemas';
import { HolterReadOutRead } from '@frontend/components/pages/episodeCategory/customControls/cardiology/holter/holterReadOut/HolterReadOutRead';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';

CustomControlRegistry.instance.register({
    ReadElement: HolterReadOutRead,
    code: CustomControlCode.HolterReadOut,
    hideEditActions: true,
    hideReadActions: true,
    initialData: initialHolterReadOutData,
    version: 1,
});
